<mz-closeable-dialog #modal [uid]="'display_dialog'" [attr.data-testid]="uid">
    <ng-content></ng-content>
</mz-closeable-dialog>
